import React, { useState } from "react";
import { BsBriefcase } from "react-icons/bs";
import { MdOutlineTheaterComedy, MdFestival, MdOutlineSportsBaseball, MdFamilyRestroom } from "react-icons/md";
import { IoSchoolSharp, IoFastFoodOutline } from "react-icons/io5";
import { GiFoodTruck, GiGuitar, GiEnergise, GiEmbrassedEnergy, GiSaxophone } from "react-icons/gi";
import { CiMusicNote1 } from "react-icons/ci";
import { FaBasketShopping } from "react-icons/fa6";
import axios from 'axios';
import { CloudUpload as CloudUploadIcon } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';
import { Box, Modal, TextField, Button, Input, Typography, MenuItem, Select, Link, InputLabel, FormControl, Checkbox, ListItemText, FormControlLabel } from "@mui/material";
import moment from "moment";
import { toast } from "react-toastify";
import { categories } from "./EventModal";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
};

function EventModal({ modalData, onSave, onClose, onDelete }) {

  // console.log('------------modaldata',modalData);
  

  // Set the state based on the modal data passed to the component
  const [title, setTitle] = useState(modalData.title);
  const [description, setDescription] = useState(modalData.description);
  const [start, setStart] = useState(modalData.start);//useState(moment(modalData.start).format("YYYY-MM-DDTHH:mm"));
  const [end, setEnd] = useState(modalData.end);//useState(moment(modalData.end).format("YYYY-MM-DDTHH:mm"));
  const [location, setLocation] = useState(modalData.location);
  const [address, setAddress] = useState( modalData.address);
  const [cimage, setCimage] = useState( modalData.cimage);
  const [link, setLink] = useState(modalData.link );
  const [selectedCategory, setSelectedCategory] = useState( modalData.category );
  const [rsvp, setRsvp] = useState( modalData.rsvp );
  const [image, setImage] = useState(modalData.cimage);

 
  const check_rsvp = () => {
    setRsvp(!rsvp);
  }

  return (
    <Modal
      open={modalData.visible}
      onClose={onClose}
      aria-labelledby="event-input-modal"
      aria-describedby="event-input-modal-description"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflowY: 'auto', // Add this line to make the modal scrollable
        // padding: '16px', // Add padding for better mobile experience
      }}
    >
      <Box sx={style}>       
        {/* Title Field */}
        <TextField
          fullWidth
          label="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          margin="normal"
          required
          slotProps={{
            input: {
              readOnly: true,
            },
          }}
        />

        {/* Location */}
        <TextField
          fullWidth
          label="Location"
          value={location}
          onChange={(e) => setLocation(e.target.value)}
          margin="normal"
          slotProps={{
            input: {
              readOnly: true,
            },
          }}
        />

        {/* Address */}
        <TextField
          fullWidth
          label="Address"
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          margin="normal"
          slotProps={{
            input: {
              readOnly: true,
            },
          }}
        />

        <Box display="flex" alignItems="center" marginY={2}>
          {cimage != '' && (
            <img src={cimage} alt="Uploaded" style={{ width: '150px' }} />
          )}

        </Box>
        {/* <Box display="flex" alignItems="center" marginY={2}>

        </Box> */}
        {/* Start Time Field */}
        <TextField
          fullWidth
          type="datetime-local"
          label="Start Time"
          value={start}
          onChange={(e) => setStart(e.target.value)}
          margin="normal"
          slotProps={{
            input: {
              readOnly: true,
            },
          }}
          style={{ marginRight: '16px' }} // Adjust spacing as needed
        />
        {/* End Time Field */}
        <TextField
          fullWidth
          type="datetime-local"
          label="End Time"
          value={end}
          onChange={(e) => setEnd(e.target.value)}
          margin="normal"
          slotProps={{
            input: {
              readOnly: true,
            },
          }}
        />
        <FormControlLabel
          control={<Checkbox checked={rsvp} onClick={check_rsvp} />}
          label="RSVP"
          style={{ paddingLeft: '250px' }}
          disabled="true"
        />

        {/* Description Field */}
        <TextField
          fullWidth
          label="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          multiline
          rows={3}
          margin="normal"
          required
          slotProps={{
            input: {
              readOnly: true,
            },
          }}
        />
        {/* <Box display="flex" alignItems="center" marginY={2}> */}
        {/* Link */}
        {/* RSVP Checkbox */}
        <Link href={link} underline="always">
          {link}
        </Link>
        {/* </Box> */}

        <FormControl fullWidth margin="normal">
          <Select
            labelId="category-select-label"
            multiple
            value={selectedCategory}
            renderValue={(selected) => selected.join(", ")} // Display selected values
            displayEmpty
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: '600px', // Set the maximum height of the dropdown menu
                  width: '150px', // Set the width of the dropdown menu
                },
              },
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
              },
            }}
            // disabled // Disable the Select component to make it read-only
          >
            {/* Dynamically render category options */}
            {Object.entries(categories).map(([category, { icon }]) => (
              <MenuItem
                key={category}
                value={category}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '1px 50px',
                  justifyContent: 'left',
                  overflowY: "auto",
                }}
              >
                <Checkbox checked={selectedCategory.indexOf(category) > -1} />
                <div style={{ display: 'flex', alignItems: 'left', marginLeft: '10px' }}>
                  {icon}
                  <Typography variant="body1" style={{ marginLeft: '5px' }}>
                    {category}
                  </Typography>
                </div>
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Actions (Save, Delete, Cancel) */}
        <Box mt={2} display="flex" justifyContent="space-between">
     
          <Button variant="outlined" onClick={onClose} color="secondary">
            Cancel
          </Button>
        </Box>
      </Box >
    </Modal >
  );
}

export default EventModal;
